import React from 'react'
import { Popup } from 'semantic-ui-react'

import { StyledMainMenuIcon } from '..'

export default function MainNavButton({
  name,
  customcolor,
  custombg,
  to,
  popupText,
  icon,
  onClick,
  isActive,
  innerRef,
}) {
  return (
    <Popup
      basic
      className="opacity-100 !font-bold"
      size="mini"
      position="right center"
      trigger={
        <StyledMainMenuIcon
          ref={innerRef}
          name={name}
          className="icon-menu"
          customcolor={customcolor}
          custombg={custombg}
          to={to}
          onClick={onClick}
          isActive={(match) => {
            if (isActive !== undefined) {
              return isActive
            } else if (match) {
              return true
            } else {
              return false
            }
          }}
        >
          <i className={`fas ${icon} text-2xl my-1.5`} />
        </StyledMainMenuIcon>
      }
      content={<div>{popupText}</div>}
      inverted
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/NavBar/MainNavButton/index.js